import React from 'react';

import styles from './LightSwipe.module.css';

interface LightSwipeProps {
  loop?: boolean; // Optional prop to enable looping (default: true)
  height?: number;
}

export const LightSwipe: React.FC<LightSwipeProps> = ({
  loop = true,
  height = 100,
}) => {
  return (
    <div className={styles.lightSwipeContainer} style={{ height: height }}>
      <div className={`${styles.lightSwipe} ${loop ? styles.loop : ''}`} />
    </div>
  );
};
